import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import theme from "../../theme";
import Icon from "../Icon";

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  margin-top: ${theme.margins.marginBig};
  padding: ${theme.margins.paddingPage};
  text-align: center;
  border: 1px solid ${theme.colors.veryLightGrey};
  box-shadow: 0 0 4px ${theme.colors.veryLightGrey};
`;

const TooltipArrow = styled.i`
  position: absolute;
  top: -15px;
  right: 0;
  margin-right: 6px;
  width: 36px;
  height: 16px;
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    left: 50%;
    top: -50%;
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.veryLightGrey};
    box-shadow: 0 0 4px ${theme.colors.veryLightGrey};
  }
`;

const CloseButton = styled(Icon)`
  position: absolute;
  top: 12px;
  right: 12px;
`;

export interface IProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
export default class Tooltip extends PureComponent<IProps, {}> {
  public render(): ReactNode {
    const { onClick, children } = this.props;

    return (
      <TooltipWrapper className={`tooltip`}>
        <TooltipArrow />
        {children}
        <CloseButton name="cross" size={24} onClick={onClick} />
      </TooltipWrapper>
    );
  }
}
